// Add your custom JS here.
(function ($) {
    // Fade in effects
    AOS.init();

    // Smooth anchor scrolling
    var scroll = new SmoothScroll('a[href*="#"]', {
        speed: 300,
    });

    const swiper = new Swiper(".swiper", {
        // Optional parameters
        direction: "horizontal",
        loop: true,
        spaceBetween: 30,
        slidesPerView: 1.1,

        // If we need pagination
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            /*Return bullets as numbers*/
            renderBullet: function (index, className) {
                return (
                    '<span class="' + className + '">' + (index + 1) + "</span>"
                );
            },
        },

        breakpoints: {
            992: {
                slidesPerView: "auto",
            },
        },

        // Navigation arrows
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },

        // And if we need scrollbar
        scrollbar: {
            el: ".swiper-scrollbar",
        },
    });
    const swiperTimeline = new Swiper(".timeline", {
        // Optional parameters
        direction: "horizontal",
        loop: false,
        spaceBetween: 1,
        slidesPerView: 1,

        // If we need pagination
        pagination: {
            el: ".swiper-pagination",
        },

        breakpoints: {
            992: {
                slidesPerView: 4,
            },
        },

        // Navigation arrows
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },

        // And if we need scrollbar
        scrollbar: {
            el: ".swiper-scrollbar",
        },
    });

    $(".faq li").on("click", function () {
        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(this).children(".a").slideUp();
        } else {
            $(".a").slideUp();
            $(".faq li").removeClass("active");
            $(this).addClass("active");
            $(this).children(".a").slideDown();
        }
    });

    $(".hamburger").on("click", function () {
        $(this).toggleClass("active");

        $(".menu-wrapper-mobile").slideToggle();
        $(".menu-wrapper-mobile").toggleClass("active");

    });

    $(".menu-wrapper-mobile a").on('click', function(){
        $(".menu-wrapper-mobile").slideToggle();
        $(".menu-wrapper-mobile").toggleClass("active");
        $(".hamburger").removeClass("active");
    })

    $(".button.share").on("click", function () {
        event.preventDefault();
        $(".addtoany").toggleClass("active");
    });

    $(".addtoany").on("click", function () {
        $(this).removeClass("active");
    });

    if ($("body").hasClass("page-id-52")) {
        $(".section-form .title h1").html("Inschrijven voor de cursus");
    }
})(jQuery);
